var render = function render(){var _vm=this,_c=_vm._self._c;return _c('flex-layout',[_c('CarouselModal'),_c('page-header',{attrs:{"heading":"Carousel","action":"Add","toggle":"offcanvas","target":"#offcanvasCreate","guard":this.$route.meta.guard},on:{"click":_vm.setCreateForm}}),_c('CarouselTable',{attrs:{"tableHeading":_vm.tableHeading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }